import React from "react"
import Header from "./Header"
import { Actions, Back, Container, OpenMpos } from "./StoreStaffNotice.styled"

type Props = {
  /** Where MPOS runs in this account; without it staff are only told to use the app */
  mposUrl?: string
  onBack: () => void
}

/** In place of the sign-in form when the account only has the store staff role */
const StoreStaffNotice = ({ mposUrl, onBack }: Props) => (
  <Container>
    <Header />
    <h3>Sell in the MPOS app</h3>
    <p>
      Your account is for store staff, so it signs in to the MPOS app rather than the Merchant
      Portal. Open MPOS on the store&apos;s phone or tablet and sign in with the same email,
      password and authenticator code.
    </p>
    <Actions>
      {mposUrl && <OpenMpos href={mposUrl}>Open MPOS</OpenMpos>}
      <Back type="button" onClick={onBack}>
        Back to sign in
      </Back>
    </Actions>
  </Container>
)

export default StoreStaffNotice
